
jq3(document).on('click mouseover', '.w-zindex', function () {
    jq3(this).closest('.w-zindex-parent').find('.w-zindex').each(function () {
        jq3(this).css('z-index', '9');
    });
    jq3(this).css('z-index', '10');
});
